<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
        </div>
        <!--<graph-submenu :position="graphPosition"/>-->

        <div class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ getAggregatedValue }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small margin-left-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="transition-transform"
                        :class="{
                            'rotate-90': difference < 0,
                            'uk-fill-disabled': (difference = 0),
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta">{{ title }}</span
            ><br />
        </div>
        <bar-part
            :chart-data="getChartData"
            :is-horizontal="true"
            :custom-chart-height="190"
            :custom-options="getCustomOptions"
        />
        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import BarPart from "./graphParts/BarPart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default GraphsMixin.extend({
    name: "VerticalBarGraph",
    components: {
        BarPart,
        GraphHelp,
        GraphModal,
    },
    mixins: [GraphsMixin],
    data() {
        return {
            activeSubmenu: false,
            dataName: "Tags used",
        };
    },
    computed: {
        getChartData() {
            return [this.chartData];
        },
        getCustomOptions() {
            const customOptions = {
                plotOptions: {
                    bar: {
                        barHeight: "50%",
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: "#999",
                        },
                        offsetY: 3,
                    },
                    axisTicks: {
                        offsetY: 0,
                    },
                    axisBorder: {
                        show: true,
                        color: "transparent",
                        offsetX: 1,
                    },
                },
                xaxis: {
                    labels: {
                        style: {
                            colors: "#999",
                        },
                        formatter: (val) => Math.round(val),
                    },
                    tickAmount: 0,
                },
            };

            if (this.chartData.data[0]) {
                const dataEntry = this.chartData.data[0];
                //Set the interval equal to the highest amount of tags used until 6
                if (dataEntry.y < 6) {
                    customOptions.xaxis.tickAmount = dataEntry.y;
                }
            }

            switch (this.chartData.data.length) {
                case this.chartData.data.length < 2:
                    customOptions.plotOptions.bar.barHeight = "10%";
                    customOptions.yaxis.labels.offsetY = -1;
                    break;
                case this.chartData.data.length < 3:
                    customOptions.plotOptions.bar.barHeight = "20%";
                    customOptions.yaxis.labels.offsetY = 1;
                    break;
                case this.chartData.data.length < 5:
                    customOptions.plotOptions.bar.barHeight = "35%";
                    customOptions.yaxis.labels.offsetY = 2;
                    break;
                case this.chartData.data.length < 6:
                    customOptions.plotOptions.bar.barHeight = "45%";
                    break;
            }

            return customOptions;
        },
    },
});
</script>
